<template>
<div>
    <Breadcrumbs main="Admin" submain="About" title="Team" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div style="display: flex; justify-content: space-between; gap: 8px;">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New</h7>
                            </button>
                            <div v-if="serial_wise_data.length > 0">
                                <button class="btn btn-secondary" type="submit" @click="updateBulkSerial">Update Bulk Serial</button>
                            </div>
                        </div>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="team_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(image)="row">
                                        <div v-if="row.item.image">
                                            <img style="width: 120px; border-radius: 4px;" :src="host + row.item.image" alt="">
                                        </div>
                                    </template>

                                    <template #cell(links)="row">
                                        <div v-if="row.item.link" style="display: flex; flex-direction: column; align-items: start; justify-items: start; gap: 5px">
                                            <div v-if="row.item.link?.facebook">
                                                <span><a :href="row.item.link?.facebook" target="_blank" rel="noopener noreferrer">Facebook</a></span>
                                            </div>
                                            <div v-if="row.item.link?.x">
                                                <span><a :href="row.item.link?.x" target="_blank" rel="noopener noreferrer">X</a></span>
                                            </div>
                                            <div v-if="row.item.link?.linked_in">
                                                <span><a :href="row.item.link?.linked_in" target="_blank" rel="noopener noreferrer">LinkedIn</a></span>
                                            </div>
                                        </div>
                                    </template>

                                    <template #cell(serial)="row">
                                        <div style="max-width: 60px;">
                                            <input @keyup.enter="updateSerial(row.item)" @keyup="getSerial(row.item)" type="text" class="form-control" v-model="row.item.serial" placeholder="Enter Serial" />
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deletePackage(data.item.id)" title="Delete"></feather>
                                            </div>

                                            <div @click="editTeam(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Team Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Team Member" size="lg" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Name</label>
                        <input class="form-control" type="text" v-model="team.name" placeholder="Enter name" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Designation</label>
                        <input class="form-control" type="text" v-model="team.designation" placeholder="Enter designation" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Serial</label>
                        <input class="form-control" type="number" v-model="team.serial" placeholder="Enter serial" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Facebook Link</label>
                        <input class="form-control" type="text" v-model="team.link.facebook" placeholder="Enter facebook link" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>X Link</label>
                        <input class="form-control" type="text" v-model="team.link.x" placeholder="Enter x link" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>LinkedIn Link</label>
                        <input class="form-control" type="text" v-model="team.link.linked_in" placeholder="Enter linkedin link" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Image</label>
                    <div>
                        <img v-if="team.image" style="height: 80px; border-radius: 6px;" :src="team.image">
                        <input :class="team.image ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadMemberImage">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Team Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Team Member" size="lg" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Name</label>
                        <input class="form-control" type="text" v-model="edit_team.name" placeholder="Enter name" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Designation</label>
                        <input class="form-control" type="text" v-model="edit_team.designation" placeholder="Enter designation" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Serial</label>
                        <input class="form-control" type="number" v-model="edit_team.serial" placeholder="Enter serial" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Facebook Link</label>
                        <input class="form-control" type="text" v-model="edit_team.link.facebook" placeholder="Enter facebook link" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>X Link</label>
                        <input class="form-control" type="text" v-model="edit_team.link.x" placeholder="Enter x link" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>LinkedIn Link</label>
                        <input class="form-control" type="text" v-model="edit_team.link.linked_in" placeholder="Enter linkedin link" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Image</label>
                    <div>
                        <img v-if="show_image" style="height: 80px; border-radius: 6px;" :src="show_image">
                        <input :class="show_image ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadMemberImage2">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Team Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this team member?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Name',
                    sortable: true
                },
                {
                    key: 'designation',
                    label: 'Designation',
                    sortable: true
                },
                {
                    key: 'image',
                    label: 'Image',
                    sortable: true
                },
                {
                    key: 'links',
                    label: 'Links',
                    sortable: false
                },
                {
                    key: 'serial',
                    label: 'Serial',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            team: {
                name: '',
                designation: '',
                serial: null,
                image: null,
                link: {
                    facebook: '',
                    x: '',
                    linked_in: ''
                }
            },

            edit_team: {
                id: '',
                name: '',
                designation: '',
                serial: null,
                image: null,
                link: {
                    facebook: '',
                    x: '',
                    linked_in: ''
                }
            },

            delete_value: null,
            show_image: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20],
            serial_wise_data: []
        };
    },

    computed: {
        ...mapState({
            team_list: state => state.teams.team,
            loading: state => state.teams.teamLoading,
            error: state => state.teams.teamError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("teams/fetchTeam").then(() => {
            this.items = this.team_list
            this.totalRows = this.team_list.length;
        });
    },

    methods: {
        updateSerial(pub) {
            this.$store.dispatch("teams/updateSerial", pub).then(response => {
                if (response.data.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.$store.dispatch("teams/fetchTeam").then(() => {
                        this.items = this.team_list
                        this.totalRows = this.team_list.length;
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        getSerial(data) {
            // remove the entry if user clears the serial
            if (!data.serial || data.serial.trim() === "") {
                this.serial_wise_data = this.serial_wise_data.filter(
                    item => item.id !== data.id
                );
                return;
            }

            // check if already exists
            const existing = this.serial_wise_data.find(item => item.id === data.id);

            if (existing) {
                // update serial
                existing.serial = data.serial;
            } else {
                // add new entry
                this.serial_wise_data.push({
                    id: data.id,
                    serial: data.serial
                });
            }
        },

        updateBulkSerial() {
            this.serial_wise_data.forEach(project => {
                this.$store.dispatch("teams/updateSerial", project).then(response => {
                    if (response.data.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.$store.dispatch("teams/fetchTeam").then(() => {
                            this.items = this.team_list
                            this.totalRows = this.team_list.length;
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                });
            });

            this.serial_wise_data = [];
        },

        uploadMemberImage(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.team.image = e.target.result
            };
        },

        uploadMemberImage2(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.edit_team.image = e.target.result
                this.show_image = e.target.result
            };
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.team = {
                name: '',
                designation: '',
                serial: null,
                link: {
                    facebook: '',
                    x: '',
                    linked_in: ''
                },
                image: null
            };
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("teams/addTeam", {
                team: this.team
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editTeam(detail) {
            this.edit_team = {
                id: detail.id || null,
                name: detail.name || '',
                designation: detail.designation || null,
                serial: detail.serial || null,
                link: {
                    facebook: detail.link ?.facebook || null,
                    x: detail.link ?.x || null,
                    linked_in: detail.link ?.linked_in || null
                }
            };
            this.show_image = this.host + detail.image || null
        },

        resetEditModal() {
            this.edit_package = {
                id: '',
                name: '',
                designation: '',
                serial: null,
                link: {
                    facebook: '',
                    x: '',
                    linked_in: ''
                },
                image: null
            };
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("teams/updateTeam", {
                id: this.edit_team.id,
                team: this.edit_team
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deletePackage(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("teams/deleteTeam", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
